<template>
	<div class="item-rate">
		<input type="hidden" class="rating" data-filled="fa fa-star item-rate-yellow item-rate" data-empty="fa fa-star item-rate-gray item-rate" data-readonly :value="render_rating"/>
	</div>
</template>

<script>
export default {
	props: ['rating'],

	computed: {
		render_rating () {
			return this.rating;
		}
	},

	ready () {
		$('.rating').rating();
	}
}
</script>


// WEBPACK FOOTER //
// Product-detail-rate-stars.vue?4af5f4a0